import { render, staticRenderFns } from "./PrenotazioniList.vue?vue&type=template&id=7e49a1af&scoped=true&"
import script from "./PrenotazioniList.vue?vue&type=script&lang=js&"
export * from "./PrenotazioniList.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioniList.vue?vue&type=style&index=0&id=7e49a1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e49a1af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SprayerManager_WebSite/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VIcon,VProgressCircular,VSubheader,VTooltip})
